module.exports = __webpack_public_path__ + "static/media/CommonCents.3ff07078.md";